<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-tabs v-model="activeTab" background-color="transparent" centered color="secondary" slider-color="secondary">
				<v-tab :key="0">اطلاعات کاربری</v-tab>
				<v-tab :key="1">دسترسی ها</v-tab>
				<v-tabs-items v-model="activeTab">
					<v-tab-item :key="0">
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field ref="username" class="left-input" v-model="localData.userName" label="نام کاربری*" :error-messages="errorMessages" :rules="[() => !!localData.userName || 'نام کاربری را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6">
								<v-checkbox color="secondary" v-model="localData.isActive" :label="'اکانت فعال'" />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field ref="firstName" v-model="localData.firstName" label="نام*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field ref="lastName" v-model="localData.lastName" label="نام خانوادگی*" :error-messages="errorMessages" :rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']" required />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field ref="mobile" v-model="localData.mobile" label="موبایل*" :error-messages="errorMessages" :rules="[() => !!localData.mobile || 'موبایل را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field ref="email" class="left-input" v-model="localData.email" label="ایمیل*" :error-messages="errorMessages" :rules="[() => !!localData.email || 'ایمیل را وارد کنید']" required />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field class="left-input" v-model="localData.password" persistent-hint :hint="localData.id !== 0 ? 'در صورت خالی بودن پسورد تغییر نخواهد کرد' : 'حداقل 8 کاراکتر'" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[(val) => !!val || (localData.id != 0 && !val) || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" @click:append="show1 = !show1" />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field class="left-input" v-model="localData.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
							</v-col>
						</v-row>
						<small>*فیلدهای ستاره دار ضروری هستند.</small>
					</v-tab-item>
					<v-tab-item :key="1">
						<v-row class="mt-5" v-if="checkPermission('Set_Permission') || isSuperAdmin">
							<v-col cols="12" md="6" class="py-0 my-0" v-for="claim in claims" :key="claim.value">
								<v-checkbox class="small" color="secondary" v-model="claim.isChecked" style="display:inline" :label="translate(claim.value)" />
							</v-col>
						</v-row>
						<v-row v-else>
							<v-col cols="12" class="red--text">
								به این بخش دسترسی ندارید.
							</v-col>
						</v-row>

					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="$emit('callbck', false)">
					بستن
				</v-btn>
				<v-btn color="blue" dark type="submit" :loading="loading">
					ذخیره
				</v-btn>
			</v-card-actions>
		</v-form>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'ModifyUserView',
		components: {
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				activeTab: 0,
				errorMessages: '',
				claims: [],
				localData: {},
				show1: false,
				show2: false,
				loading: false,
			}
		},
		mounted() {
			this.prepareData()
		},
		computed: {
			isSuperAdmin: get('auth/isSuperAdmin')
		},
		methods: {
			refreshUserClaims: call('auth/refreshUserClaims'),
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.localData.claims = this.claims.filter(x => x.isChecked == true)
				this.loading = true
				api.post('admin/user/' + (this.localData.id === 0 ? 'create' : 'edit'), this.localData)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.refreshUserClaims()
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.loading = false
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('admin/user/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === 0) Object.assign(this.localData, this.data)
							api.get('admin/user/ClaimsList', null)
								.then(
									response => {
										this.claims = response
										this.claims.forEach(x => {
											if ((this.localData.claims || []).findIndex(claim => claim.value == x.value) > -1)
												x.isChecked = true
										})
									})
								.catch(err => {
									toast.error(err.message)
								})
						})
					.catch(err => {
						toast.error(err.message)
					})

			},
			translate(text) {
				let translate = {
					'Delete_Installmet': 'حذف قسط',
					'Chackout_Loan': 'تسویه وام',
					'Delete_Loan': 'حذف وام',
					'Set_Permission': 'تعیین دسترسی',
					'Dashboard_Stats': 'آمار سیستم در داشبورد',
					'ManualWalletTransaction': 'واریز/برداشت کیف پول',
					'AppSettings_TotalSettingsTab': 'تنظیمات اپلیکیشن_تنظیمات کلی',
					'AppSettings_FinancialTab': 'تنظیمات اپلیکیشن_تنظیمات مالی',
					'AppSettings_FinotechTab': 'تنظیمات اپلیکیشن_تنظیمات فینوتک',
					'AppSettings_IranValidityTab': 'تنظیمات اپلیکیشن_تنظیمات اعتبارسنجی',
					'AppSettings_LandingPageTab': 'تنظیمات اپلیکیشن_تنظیمات صفحه شخصی',
					'AppSettings_RefahBetaTab': 'تنظیمات اپلیکیشن_بتا رفاه',
					'BackupRestore': 'بکاپ و بازیابی',
					'Loans': 'تعریف وام ها',
					'Members': 'مشتری ها',
					'PaymentRequests': 'اعلام واریزها',
					'LoanRequests': 'درخواست وام ها',
					'Agents': 'نماینده ها',
					'Contacts': 'طرف حساب ها',
					'Marketers': 'بازاریاب ها',
					'Sms': 'پیامک ها',
					'Reports': 'گزارش ها',
					'Users': 'کاربران',
					'ExportExcel': 'صدور فایل اکسل',
					'Tickets': 'تیکت ها',
					'Email': 'ایمیل',
					'CustomerOrders': 'سفارش خرید ها',
					'Cancel_Loan': 'فسخ پرونده وام',
					'Inquiry': 'استعلام',
					'Sponsors': 'اسپانسر ها'
				}
				return translate[text] ? translate[text] : text
			}
		},
	}
</script>
<style></style>
